import React, { Component } from "react";
import PropTypes from "prop-types";
import {Textarea} from "components/MeasureTaskItem/Checklist/Textarea";
import ChecklistItems from "./ChecklistItems";
import { withTranslation } from "react-i18next";
import Label from "components/MeasureTaskItem/Checklist/Label";
import {TextInput} from "components/MeasureTaskItem/Checklist/TextInput";

class ChecklistForm extends Component {

    handleLabelChange = (event) => {
        const { readOnly } = this.props;
        if (readOnly) return;
        const { value } = event.target;
        const { saveLabel } = this.props;
        saveLabel(value);
    };

    handleDescriptionChange = (event) => {
        const { readOnly } = this.props;
        if (readOnly) return;
        const { value } = event.target;
        const { saveDescription } = this.props;
        saveDescription(value);
    };

    render() {

        const {
            index,
            addItem,
            saveItem,
            removeItem,
            t,
            checklist,
            error,
            reorderItems,
            readOnly
        } = this.props;

        const { label, description, items } = checklist;

        return (
            <div className="column checklist-form">
                <div className="columns">
                    <div className="column">
                        <TextInput
                            type="text"
                            autoFocus={false}
                            name="label"
                            value={label}
                            onChange={(event) => this.handleLabelChange(event)}
                            label={t("checklist.add.name.label")}
                            dataTestId={`checklistLabel${index}`}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <Textarea
                            name="description"
                            value={description}
                            onChange={(event) => this.handleDescriptionChange(event)}
                            label="Description"
                            data-testid={`checklistDescription${index}`}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                {error ?
                    <div className="columns">
                        <div className="column">
                            <div className="notification is-okcomply-red">
                                <p className="has-text-white">
                                    <strong>{error}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    : null}
                <div className="columns">
                    <div className="column">
                        <Label label={t("checklist.items")} />
                    </div>
                </div>
                <div style={{ marginBottom: "1rem" }} />
                <ChecklistItems
                    items={items}
                    handleOnChange={saveItem}
                    handleReorder={reorderItems}
                    addItem={addItem}
                    removeItem={removeItem}
                    readOnly={readOnly}
                />
            </div>);
    }
}

ChecklistForm.propTypes = {
    index: PropTypes.number.isRequired,
    addItem: PropTypes.func.isRequired,
    saveItem: PropTypes.func.isRequired,
    removeItem: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    checklist: PropTypes.object.isRequired,
    error: PropTypes.string.isRequired,
    saveLabel: PropTypes.func.isRequired,
    saveDescription: PropTypes.func.isRequired,
    reorderItems: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
};

export default withTranslation()(ChecklistForm);
